export const aboutData = {
    title: "Little about me",
    description1:"🏡 I live in Ankleshwar,Bharuch, Gujarat.",
    description2:" 👨‍👨‍👦‍👦 I belong to a family of five.",
    description3:"😍 I like playing outdoor sports like football.",
    description4:"🤗 When i'm free; I like to explore startups, watch ted talks, and read novels.",
    image: 1
}